export default __webpack_public_path__ + "static/media/facebookLogo.3b447323.svg";